import React from 'react'
import { Button, Select, Typography, Modal } from 'antd'
import { LockOutlined, UnlockOutlined } from '@ant-design/icons'
import { blockReasonOptions } from '../utils'

const { Title, Text } = Typography

const BlockingTab = ({
  event,
  reason,
  setReason,
  blockingActionBusy,
  handleBlockout,
  showReasonModal,
  setShowReasonModal,
  token
}) => {
  return (
    <>
      <div style={{ padding: 12, textAlign: 'center' }}>
        <Title level={5} style={{ fontSize: '14px' }}>
          {event?.extendedProps?.blocked ? 'Unblock This Time Slot' : 'Block This Time Slot'}
        </Title>

        {!event?.extendedProps?.blocked && (
          <div style={{ marginBottom: 12 }}>
            <Text style={{ marginBottom: 4, display: 'block', fontSize: '12px' }}>Select a reason for blocking:</Text>
            <Select
              placeholder='- Select Reason -'
              value={reason ? reason : null}
              style={{ width: '100%', marginBottom: 8 }}
              size='middle'
              onChange={(value) => setReason(value)}
              options={blockReasonOptions.map((r) => ({ label: r, value: r }))}
            />
          </div>
        )}

        <Button
          type='primary'
          icon={
            event?.extendedProps?.blocked ? (
              <UnlockOutlined style={{ color: 'white' }} />
            ) : (
              <LockOutlined style={{ color: 'white' }} />
            )
          }
          loading={blockingActionBusy}
          disabled={!event?.extendedProps?.blocked && !reason}
          onClick={() => {
            if (event?.extendedProps?.blocked) {
              handleBlockout(true)
            } else if (reason) {
              handleBlockout(false)
            } else {
              setShowReasonModal(true)
            }
          }}
          style={{
            background: event?.extendedProps?.blocked ? token.colorSuccess : token.colorWarning,
            borderColor: event?.extendedProps?.blocked ? token.colorSuccess : token.colorWarning
          }}
          size='middle'
        >
          {event?.extendedProps?.blocked ? 'Unblock Slot' : 'Block Slot'}
        </Button>
      </div>

      <Modal
        title={
          <div style={{ textAlign: 'center' }}>
            <LockOutlined style={{ marginRight: 6, color: token.colorPrimary }} />
            Block Time Slot
          </div>
        }
        open={showReasonModal}
        destroyOnClose
        centered
        okButtonProps={{
          disabled: !reason,
          style: { background: token.colorWarning, borderColor: token.colorWarning }
        }}
        onOk={() => {
          handleBlockout(false, reason)
          setShowReasonModal(false)
        }}
        okText='Block Slot'
        onCancel={() => {
          setReason('')
          setShowReasonModal(false)
        }}
        cancelButtonProps={{ style: { background: 'transparent' } }}
        cancelText='Cancel'
      >
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <Text style={{ fontSize: '13px' }}>Please select a reason for blocking this time slot:</Text>
        </div>
        <Select
          placeholder='- Select Reason -'
          value={reason ? reason : null}
          style={{ width: '100%' }}
          size='middle'
          onChange={(value) => setReason(value)}
          options={blockReasonOptions.map((r) => ({ label: r, value: r }))}
        />
      </Modal>
    </>
  )
}

export default BlockingTab
